import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const AdminPlatformUpdates = lazy(() => import("@/pages/admin/AdminPlatformUpdates"));

export const Route = createFileRoute("/admin/platform-updates")({
  component: AdminPlatformUpdates,
});
